import { render, staticRenderFns } from "./SettingsIcon.vue?vue&type=template&id=1c7e59b6&"
import script from "./SettingsIcon.vue?vue&type=script&lang=ts&"
export * from "./SettingsIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports